import { straightForwardProjectHandling } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

interface Props {
    localization: ILocalization;
}
export const StraightForwardProjectHandlingSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='project-handling-slide'>
                <img alt='' src={straightForwardProjectHandling} />
            </div>
        </div>
    );
};

export const StraightForwardProjectHandlingSlideImageSrc =
    straightForwardProjectHandling;

export const StraightForwardProjectHandlingSlideContent = ({
    localization,
}: Props) => {
    const { straightForwardProjectHandling } =
        localization.localizationStrings.susy.thesisManagement.tutorial
            .supervisor.slides;

    return (
        <div className='tutorial-content-wrapper' data-testid='second-slide'>
            <h1>{straightForwardProjectHandling.straightForward}​​</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {straightForwardProjectHandling.withinTheir}{' '}
                    <span className='instruction-content-bold'>
                        {straightForwardProjectHandling.differentStatuses}{' '}
                    </span>
                    {straightForwardProjectHandling.accordingToDecisions}
                    <div />
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {straightForwardProjectHandling.allActions}{' '}
                    <span className='instruction-content-bold'>
                        {straightForwardProjectHandling.deadlines}{' '}
                    </span>
                    {straightForwardProjectHandling.whichWill}
                </div>
            </div>
        </div>
    );
};
